<template>
    <div class="title">手机验证</div>
    <el-form>
      <el-form-item>
        <div class="check_txt">发送验证码至：{{ formData.phoneZone }} {{ formData.phoneNumber }}</div>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="verificationCode"
          placeholder="请输入验证码"
          size="large"
          class="input_style"
          @focus="focusHandle"
          @change="verfiyCodeChange"
          @blur="inputBlur"
          >
          <template #append>
            <img v-if="isFocus && verificationCode" @click.stop="clearVcCode" class="clear_icon" src="@/assets/images/login/clear_icon.svg" alt="">
            <div class="get_code_btn" v-if="countDown == 0" @click="varify">获取验证码</div>
            <div class="countDown_btn" v-else>{{ countDown + " 秒后重新获取" }}</div>
          </template>
        </el-input>
      </el-form-item>
  
      <el-button
          class="submit-btn"
          size="large"
          type="primary"
          text
          bg
          @click="nexHandle"
          >下一步</el-button
        >
    </el-form>
  
    <!-- 没点击同意协议 -->
    <agreementHandle ref="agreeModel" @canLogin="agreeHandle"/>
    
  </template>
    
  <script setup>
  import { messageError } from '@/utils/message';
  import { validatePhoneNumber } from "@/utils/common";
  import { varifyCodeHandle } from "@/utils/public.js";
  import agreementHandle from './agreementHandle.vue'; //
  import { ref,onMounted, reactive, onBeforeUnmount } from "vue";
  import requestApi from "@/api/index";
  import { useLoginStore } from './store';
  import bus from '@/utils/bus'
  const emits = defineEmits(['to', 'focus', 'blur']);

  const props = defineProps([
    'ctxPhoneZone',
    'ctxPhoneNumber',
    'ctxAgreementCheckOut'
  ])
  const formData = reactive({ //表单
    phoneZone:'',
    phoneNumber:'',
    agreementCheckOut: false, //是否勾选了协议
    type: 'register',
    ticket: '',
    randstr: ''
})
  const loginStore = useLoginStore();
  const verificationCode = ref(""); //验证码
  const isFocus = ref(false);//是否聚焦
  const isSending = ref(false);
  const countDown = ref(0); //倒计时
  const agreeModel = ref(null);
  

  const VccCheckInit =() => {
    formData.phoneZone = props.ctxPhoneZone;
    formData.phoneNumber = props.ctxPhoneNumber;
    formData.agreementCheckOut = props.ctxAgreementCheckOut;
    console.log('VccCheckInit',formData)
  }
  // 清除验证码
  const clearVcCode = () =>{
    verificationCode.value = '';
  }
  
  // 聚焦显示
  const focusHandle = () =>{
    isFocus.value = true;
    emits('focus')
  }
  
  const inputBlur = () =>{
    emits('blur')
  }
  
  // 验证手机
  const validatePhone = () => {
    if (formData.phoneNumber.length == 0) {
      messageError("请输入手机号", 40);
      return false;
    }
  
    // 验证手机号是否正确
    if (validatePhoneNumber(formData.phoneNumber, formData.phoneZone) == false) {
      messageError("手机号码格式不正确", 40);
      return false;
    }
  
    return true;
  };
  
  
  // 验证二维码
  const validateCode = () => {
    if (verificationCode.value.length == 0) {
      messageError("请输入验证码", 40);
      return false;
    }
  
    return true;
  };

  // 输入验证码
  const verfiyCodeChange = (val) => {
    loginStore.changeVerifyCode(val);
  }
  
  // 开始倒计时
  const startCountdown = () => {
    const intervalId = setInterval(() => {
      countDown.value--;
      if (countDown.value === 0) {
        clearInterval(intervalId);
      }
    }, 1000);
  };

  // 发送验证码前验证
  const varify= ()=> {
  // varifyCodeHandle((res)=>{
  //   formData.ticket = res.ticket;
  //   formData.randstr = res.randstr;
    sendVerificationCode()
  // },()=>{
  //   messageError('验证失败，请重试');
  // })
  }
  
  // 发送验证码
  const sendVerificationCode = () => {
    if (validatePhone() == false) {
      return false;
    }
  
    requestApi.loginModule
    .sendSmsVerifyCode({
      phone: formData.phoneNumber,
      zoneNum: formData.phoneZone,
      type: formData.type,
      ticket: formData.ticket,
      randstr: formData.randstr
    })
    .then((response) => {
      const result = response.data;
      console.log(result);
      if (result.code == 200) {
        isSending.value = true;
        setTimeout(() => {
          isSending.value = false;
          countDown.value = 60;
          startCountdown();
        }, 100);
      } else if(result.code == 55503 || result.code == 55506) {
        messageError('每天最多可发送5条短信', 40);
        return false;
      } else {
        let errMsg = result.msg != undefined ? result.msg : "系统错误";
        messageError(errMsg, 40);
        return false;
      }
    }).catch(reason => {
      console.error(reason);
      messageError(reason, 40);
    });
  };
  
  // 下一步
  const nexHandle = () => {
    if (validatePhone() == false || validateCode() == false) {
      return false;
    }
  
    if(!formData.agreementCheckOut){
      agreeModel.value.agreeShow = true;
      return false;
    }
    requestApi.loginModule.checkVerifyCode({
      phone: formData.phoneNumber,
      zoneNum: formData.phoneZone.replace(/[^\d]/g, ''),
      type: formData.type,
      verifyCode: verificationCode.value
    }).then(response => {
      const result = response.data;
      if (result.code != 200) {
        let errMsg = result.msg != undefined ? result.msg : "系统错误";
        messageError(errMsg, 40);
        return false;
      }
      tosetPwd();
  
    });
  
    return true;
  };

  // 使用密码登录
  const tosetPwd = () => {
    emits('to',{
      model:'PwdSettingForm', 
      hasBack:true, 
      hasAgreement:true,
      isForgetPwd: false,
      nexSetingShow: false
    })
  }
  
  // 同意并执行下一步
  const agreeHandle = () =>{
    formData.agreementCheckOut = true;
    loginStore.changeAgreementCheck(true)
    bus.emit('changeAgreement', true)
    nexHandle();
  }

  const enterKeyDown = (event) =>{
    if(event.key == 'Enter'){
      nexHandle();
    }
  }
  
  
  onMounted(()=> {
    VccCheckInit();
    // 第一个参数：为事件的类型，第二个参数为事件的回调
    bus.on('agreement',(val)=> {   //on(收东西!!)
      console.log('val',val);
      formData.agreementCheckOut = val
    })
    document.addEventListener('keydown', enterKeyDown)
  })

  onBeforeUnmount(()=> {
    document.removeEventListener('keydown', enterKeyDown);
  })
  
  
  defineExpose({
    isSending,
    countDown,
    sendVerificationCode,
  });
  </script>
    
  
  <style lang="scss" scoped>
    @import url(./styles/index.scss);
    .check_txt{
        color:#212429;
        font-family: PingFang SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
    }
    .submit-btn {
      --el-button-hover-text-color: #ffffff;
      width: 100%;
      border-radius: 25px;
      font-size: 16px;
      height: 48px;
    }
  </style>